import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, CategoryDto, DynamicFormDto, DynamicPayloadDto, MemberDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpBankService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/bank', authService);
	}
	public getForm(): Observable<DynamicFormDto> {
		return super.doGet(true, "/form");
	}
	public get(id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${id}`);
	}
	public create(payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/`, payload);
	}
	public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public getAll(): Observable<CategoryDto[]> {
		return super.doGet(true, "/");
	}
}
